export default () => ({
  mobileMenuShown: false,
  openMobileMenu() {
    this.mobileMenuShown = true;
  },
  closeMobileMenu() {
    this.mobileMenuShown = false;
  },
  isMobileMenuShown() {
    return this.mobileMenuShown === true;
  },
  isDesktop() {
    return this.isDesktop === true;
  },
});
